import type { Namespace } from '../types';

// DE drafted — queued for native review in the task file's "DE review queue".
export const completeRegistration = {
  invalidLink: {
    de: 'Ungültiger Einladungslink — kein Token gefunden.',
    en: 'Invalid invitation link — no token found.',
  },
  invalidOrExpired: {
    de: 'Diese Einladung ist ungültig oder abgelaufen. Bitten Sie einen Admin, sie erneut zu senden.',
    en: 'This invitation is invalid or has expired. Ask an admin to resend it.',
  },

  doneTitle: { de: 'Konto erstellt!', en: 'Account created!' },
  donePrefix: { de: 'Ihr Konto für', en: 'Your account for' },
  doneSuffix: { de: 'ist bereit.', en: 'is ready.' },
  goToLogin: { de: 'Zur Anmeldung', en: 'Go to login' },

  title: { de: 'Registrierung abschließen', en: 'Complete registration' },
  subtitle: { de: 'Richten Sie Ihr Konto ein, um zu starten.', en: 'Set up your account to get started.' },
  confirmPassword: { de: 'Passwort bestätigen', en: 'Confirm password' },
  createAccount: { de: 'Konto erstellen', en: 'Create account' },
} as const satisfies Namespace;
